/**
 * Template Variables Data Structure
 *
 * Centralized definition of available template variables for appointment reminders.
 * This structure is extensible and can be used by both frontend and backend.
 *
 * Variables are organized by category for better UX and maintainability.
 */

export const templateVariables = [
  // Patient Information
  {
    key: "name",
    displayName: "Patient Name",
    description: "The name of the patient",
    category: "Patient",
    example: "John Doe"
  },

  // Appointment Information
  {
    key: "date",
    displayName: "Appointment Date",
    description: "The date of the appointment",
    category: "Appointment",
    example: "2025-02-20"
  },
  {
    key: "day_of_week",
    displayName: "Day of Week",
    description: "The day of the week for the appointment (e.g., Monday, Tuesday)",
    category: "Appointment",
    example: "Monday"
  },
  {
    key: "time",
    displayName: "Appointment Time",
    description: "The start time of the appointment",
    category: "Appointment",
    example: "10:00 AM"
  },

  // Doctor Information
  {
    key: "doctor",
    displayName: "Doctor Name",
    description: "The name of the doctor",
    category: "Doctor",
    example: "Dr. John Smith"
  },

  // Clinic Information
  {
    key: "clinic",
    displayName: "Clinic Name",
    description: "The name of the clinic",
    category: "Clinic",
    example: "Central Medical Clinic"
  },
  {
    key: "location",
    displayName: "Clinic Location",
    description: "The address of the clinic",
    category: "Clinic",
    example: "123 Central Street, Central, Hong Kong"
  },
  {
    key: "address",
    displayName: "Clinic Address",
    description: "The address of the clinic (alias for location)",
    category: "Clinic",
    example: "123 Central Street, Central, Hong Kong"
  }
];

/**
 * Get variables grouped by category
 */
export const getVariablesByCategory = () => {
  const grouped = {};
  templateVariables.forEach(variable => {
    if (!grouped[variable.category]) {
      grouped[variable.category] = [];
    }
    grouped[variable.category].push(variable);
  });
  return grouped;
};

/**
 * Get variable by key
 */
export const getVariableByKey = (key) => {
  return templateVariables.find(v => v.key === key);
};

/**
 * Get all unique categories
 */
export const getCategories = () => {
  return [...new Set(templateVariables.map(v => v.category))];
};
